(function () {
    'use strict';

    $(document).ready(function() {
        $('#box-products-content .tabs').on('click','a', function(e){
            e.preventDefault();
            var _that = $(this);
            var tab = $(this).data("tab");
            _that.parent().siblings().removeClass('active');
            _that.parent().addClass('active');
            $('#' + tab).siblings().removeClass('active');
            $('#' + tab).addClass('active');
        });    
    });

})();